import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'outpatient-edit',
  data: function () {
    return {
      patientCode: null,
      isNewOutPatient: false,
      utils: utils,
      searchCallbackFlag: false,
      canValidate: false,  // true -> 実行
      showValidate:{ // true -> 警告表示
        shop_id: false,
        create_date: false,
        creator_id: false,
        patient_name: false,
        outpatientFurigana: false,
        birthday: false,
        sex: false,
      },
      // 外来患者
      out: {
        outpatient_id: null,
        create_date: utils.getDate2Str(new Date()),
        shop_id: null,
        outpatient_name: '',
        outpatient_name_furigana: '',
        sex: null,
        creator_id: null,
        creator_name: null,
        birthday: null,
        patient_code: null,
      },
      // 正常入力値保持用
      ac: {
        creator_name: null,
      },
      isDetailFlag:  false,
      isNsipsFlag: false,
    }
  },
  created: function () {
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.isNewOutPatient = utils.isBlank(this.$route.params.outpatientId)
    this.clearSearch()
    if (!this.isNewOutPatient){
      // 編集
      this.$store.dispatch('USER_ADMIN_PHARMACIST') // システム管理者 または 薬剤師
      this.search()
    } else {
      // 新規作成
      var self = this
      var callbackPharmacist = function () {
        if (self.isAdminOrPharmacist) {
          self.out.creator_id    = self.userAdminOrPharmacistId
          self.out.creator_name  = self.userAdminOrPharmacistName
          self.ac.creator_name    = self.userAdminOrPharmacistName
        }
        self.outBackup = utils.clone(self.out)
        self.searchCallbackFlag = true
      }
      // システム管理者 または 薬剤師
      this.$store.dispatch('USER_ADMIN_PHARMACIST', {callback: callbackPharmacist})

      // NSIPS 患者コード
      if(this.$router.currentRoute.query.nsips == 'patient'){
        this.isNsipsFlag = true 
        if (utils.isPresent(this.$router.currentRoute.query.patient_code)) {
          var self = this
          var callback = function () {
            self.patientCode = self.nsPatient.attributes['patient-code']
            self.out.outpatient_name = self.nsPatient.attributes['patient-name']
            self.out.sex = self.nsPatient.attributes['gender']
            self.out.birthday = self.nsPatient.attributes['birthday']
          }
          this.$store.dispatch('NS_PATIENT_SEARCH', {
            data: { patient_code: this.$router.currentRoute.query.patient_code, shop_id: this.$router.currentRoute.query.shop_id },
            callback: callback
          })
        }
      }
    }

    if (this.$store.getters.canManage) {
      this.out.shop_id = this.$store.getters.currentShopId
    }
    this.isNewOutpatient = utils.isBlank(this.$route.params.outpatient_id)

    this.clearSearch()
    if (!this.isNewOutPatient) {
      this.search()
    }
    this.canValidate = true // 最初からValidateする
    Object.keys(this.showValidate).forEach(key => { this.showValidate[key] = true; }) // 最初から警告表示する
    // オートコンプリートイベント
    utils.autocompleteEvent({$:$, elem:'#creator_name_autocomplete',    search:() => {}, searchParams:false, searchAutocomplete:this.getCreators,    setSearchData:this.setSearchCreator,   clear: this.clearCreators})
    // 詳細画面からの遷移
    if ('outpatientId' in this.$route.params) {
      this.isDetailFlag = true
    }
  },
  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    outpatient() {
      return this.$store.getters.outpatient
    },
    shops () {
      return this.$store.getters.shops.filter((o) => {return o.id != null}) // 全店舗は不可
    },
    creators () {
      return this.$store.getters.usersAutocomplete
    },
    /** システム管理者 または 薬剤師 */
    isAdminOrPharmacist() {
      return this.$store.getters.userAdminOrPharmacist
    },
    /** システム管理者 または 薬剤師 ユーザーID */
    userAdminOrPharmacistId() {
      return this.$store.getters.userAdminOrPharmacistId
    },
    /** システム管理者 または 薬剤師 ユーザー名 */
    userAdminOrPharmacistName() {
      return this.$store.getters.userAdminOrPharmacistName
    },
    /** 必須チェック */
    required: function() {
      return {
        outpatientName:        utils.isBlank(this.out.outpatient_name),               // 外来患者
        outpatient_name_furigana_format: !utils.isHiragana(this.out.outpatient_name_furigana,false),    // ひらがな
        create_date:           utils.isBlank(this.out.create_date),　　　　　　　　// 作成日
        birthday:              utils.isBlank(this.out.birthday),                // 生年月日
        patientCode: !utils.regex.numerical.test(this.patientCode),
        sex: utils.isBlank(this.out.sex),
      }
    },
    /** 必須チェック全てOK */
    isRequiredComplete () {
      var req  = this.required
      var result = true
      // 必須
      for (var key in req) {
        if (req[key]) {
          result = false
          break
        }
      }
      return result
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    /** 通知 */
    notify() {
      return this.$store.getters.outpatientNotify
    },
    /** 各日付 (和暦) */
    createDate: {
      get: function () {return this.getWareki(this.out.create_date)},
      set: function (v) {this.out.create_date = this.getSeireki(v)}
    },
    birthday: {
      get: function () {return this.getWareki(this.out.birthday)},
      set: function (v) {this.out.birthday = this.getSeireki(v)}
    },
    defaultBirthday: function () {
      var d = new Date()
      d.setYear(d.getFullYear()-80)
      return d
    },
    /** バリデーション */
    validation: function() {
      var v = {
        shop_id: !!this.out.shop_id,
        create_date: !!this.out.create_date,
        creator_id: !!this.out.creator_id,
        outpatient_name: !!this.out.outpatient_name,
        sex: this.out.sex == 0 || this.out.sex == 1 ? true : false,
        birthday: !!this.out.birthday,
        patient_code: utils.regex.numerical.test(this.out.patient_code),
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    nsPatient () {
      return this.$store.getters.ns_patient
    }
  },
  methods: {
    search: function () {
      var data = {
         outpatient_id: this.$route.params.outpatientId
      }
      var self = this
      var callback = function (data) {
        if (utils.isBlank(self.outpatient)) {
          //self.goPrev()
          //return
        }
        self.out.create_date = data[0].attributes['create-time-value']
        self.out.creator_name = data[0].attributes['creator-name']
        self.out.creator_id = data[0].attributes['creator-id']
        self.out.outpatient_name = data[0].attributes['outpatient-name']
        self.out.outpatient_name_furigana = data[0].attributes['outpatient-name-furigana']
        self.out.sex = data[0].attributes['sex-value']
        self.out.birthday = data[0].attributes['birthday-value']
        self.patientCode = data[0].attributes['patient-code']
        self.searchCallbackFlag = true
      }
      this.searchCallbackFlag = true
      this.$store.dispatch('OUTPATIENT_SEARCH_DETAIL', { outpatientId: this.$route.params.outpatientId, data: data, callback: callback })
    },
    goPatientList: function () {
      this.$router.push({ path: '/patients/list', query: { type: this.$router.currentRoute.query.type } })
    },
    goOutpatientList: function () {
      this.$router.push({ path: '/outpatients/list', query: { type: this.$router.currentRoute.query.type } })
    },
    onClickSave: function () {
      this.save()
    },
    goNext: function (id) {
      this.$router.push({ path: '/outpatients/detail/' + id, query: { type: this.$router.currentRoute.query.type } })
    },
    /** 店舗 */
    onChangeShop: function () {
      // 店舗の変更時、作成者をクリア
      this.out.creator_id = null
      this.out.creator_name = null
      this.ac.creator_name = null
    },
    save: function(){
      var outpatientId = null
      if (utils.isPresent(this.$route.params.outpatientId)) {
        outpatientId = this.$route.params.outpatientId
      }
      var data = {
        shop_id: this.out.shop_id,
        creator_id: this.out.creator_id,
        outpatient_id: outpatientId,
        outpatient_name: this.out.outpatient_name,
        outpatient_name_furigana: this.out.outpatient_name_furigana,
        birthday: this.out.birthday,
        sex: this.out.sex,
        create_date: this.out.create_date,
        patient_code: this.patientCode
      }
      var self = this
      var callback = function () {
        self.goPrev()
      }
      this.$store.dispatch('OUTPATIENT_EDIT', {data: data, callback: callback})
    },
    goPrev: function () {
      if ('outpatientId' in this.$route.params) {
        this.$router.push({ path: '/outpatients/detail/' + this.$route.params.outpatientId, query: { type: this.$router.currentRoute.query.type } })
      } else if(this.$router.currentRoute.query.nsips == 'patient'){
        this.$router.push({ path: '/nsips/patients/list'})
      } else{
        this.goOutpatientList()
      }
    },
    clearSearch: function () {
      this.$store.dispatch('OUTPATIENT_EDIT_CLEAR')
    },
    trim: function (name) {
      if (!name) return ''
      if (name.trim() == this.$t('none_list.name')) return ''
      return name.trim()
    },
    /** 作成者 */
    getCreators: function () {
      // 管理者 薬剤師のみ選択可能
      this.$store.dispatch('USER_SEARCH', {
        data: {
          shop_id: this.out.shop_id,
          user_authority_or_pharmacist_flag: 1,
          user_name: this.out.creator_name,
          all_get: true,
        },
        loadparams: false,
        autocomplete: true, noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
      })
    },
    clearCreators: function () {
      if (this.ac.creator_name !== this.out.creator_name) {
        this.out.creator_name = this.ac.creator_name
        this.$store.dispatch('PLAN_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.showValidate.creator_id = true
      this.$store.dispatch('USER_AUTOCOMPLETE_CLEAR')
    },
    setSearchCreator: function (id, name) {
      var nm = this.trim(name)
      this.out.creator_id = id
      this.out.creator_name = nm
      this.ac.creator_name = nm
      this.$store.dispatch('USER_AUTOCOMPLETE_CLEAR')
    },
    lazyExec: function (func) {
      // setTimeout(func}, utils.key_delay)
      this.$nextTick(func)
    },
    /** 日付 (和暦) 用 */
    getWareki: function (seireki_str) {
      if ((!seireki_str) || isNaN(Date.parse(seireki_str))) {
        return ''
      } else {
        return utils.sereki2Wareki(this.$t, new Date(Date.parse(seireki_str)))
      }
    },
    getSeireki: function (wareki_str) {
      return utils.wareki2Seireki(this.$t, wareki_str, 'y-m-d')
    },
    getHHMM: function (seireki_str) {
      var d = new Date(Date.parse(seireki_str))
      return ("0"+d.getHours()).slice(-2) + ":" + ("0"+d.getMinutes()).slice(-2)
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/outpatient-edit.js